import React from 'react';
import { CompanyAdminMeta, Team } from '@dispatch/shared/types';
import { AdminDashboardTable } from './AdminDashboardTable';
import { actionsColumn, clickToCopy, textColumn } from '@dispatch/web/ui';
import {
  GridActionsCellItem,
  GridColDef,
  GridRowParams,
} from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { handleModalOpen, onClick } from './helpers';

export const TeamAdmin = ({
  teams = [],
  modalState,
  isLoading,
}: {
  teams?: Team[];
  modalState?: {
    meta: CompanyAdminMeta;
    setmeta: React.Dispatch<CompanyAdminMeta>;
  };
  isLoading?: boolean;
}) => {
  const handleClick = React.useCallback(
    (params: GridRowParams) => onClick('addTeam', params, modalState),
    [modalState?.meta.addTeam]
  );

  const handleDelete = React.useCallback(
    (params: GridRowParams & { type?: string }) => {
      params.type = 'team';
      onClick('delete', params, modalState);
    },
    [modalState?.meta]
  );

  const columns: GridColDef[] = [
    clickToCopy({
      field: 'integrationGUID',
      headerName: 'ID',
    }),
    textColumn({
      field: 'externalTeamId',
      headerName: 'External ID',
    }),
    textColumn({
      field: 'name',
      headerName: 'Name',
    }),
    actionsColumn((params: GridRowParams) => [
      <GridActionsCellItem
        key="edit"
        icon={<EditIcon />}
        label="EDIT"
        onClick={() => {
          handleClick(params);
        }}
        showInMenu
      />,
      <GridActionsCellItem
        key="delete"
        icon={<DeleteIcon />}
        label="DELETE"
        onClick={() => {
          handleDelete(params);
        }}
        showInMenu
      />,
    ]),
  ];

  return (
    <AdminDashboardTable<Team>
      isLoading={isLoading}
      columns={columns}
      data={teams}
      type="team"
      identifier="integrationGUID"
      handleClick={() => handleModalOpen('addTeam', modalState)}
    />
  );
};
